<template>

    <div class="header__choice" :class="{'header__choice__desktop-size': desktopSize}">
        <button class="header__btn__template text-baseMedium"
                :class="{
            'header__btn__template__desktop-size': desktopSize,
            'header__btn__template__active': newslettersPage === ENUM.NEWSLETTERS.PAGE.CARDS,
        }"
                @click="clickUpdateNewslettersPage(ENUM.NEWSLETTERS.PAGE.CARDS)">
            {{ $t('cleaning_cards') }}
        </button>
        <button class="header__btn__template text-baseMedium"
                :class="{
            'header__btn__template__desktop-size': desktopSize,
            'header__btn__template__active': newslettersPage === ENUM.NEWSLETTERS.PAGE.LIST,
        }"
                @click="clickUpdateNewslettersPage(ENUM.NEWSLETTERS.PAGE.LIST)">
            {{ $t('cleaning_list') }}
        </button>
    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'

import Tag from '../../modules/tag'

export default {

    name: 'newsletters-toggle',

    props: {
        desktopSize: {
            type: Boolean,
            default: false
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'newslettersPage'
        ]),

        ENUM() {
            return ENUM
        }
    },

    methods: {

        ...Vuex.mapActions([
            'updateNewslettersPage'
        ]),

        clickUpdateNewslettersPage(newPage) {
            newPage === ENUM.NEWSLETTERS.PAGE.LIST
                ? Tag.clickGA(this, 'list')
                : Tag.clickGA(this, 'cards')

            this.updateNewslettersPage(newPage)
        }
    }
}
</script>

<style lang="scss" scoped>

.header__choice {
    border-radius: 72px;
    padding: 2px;
    background-color: $white;
    display: flex;
    flex-direction: row;

    &__desktop-size {
        background-color: $timberwolf;
    }
}

.header__btn__template {
    padding: 8px 16px;
    border-radius: 72px;
    color: $midnight;
    background-color: $white;
}

.header__btn__template__desktop-size {
    background-color: $timberwolf;
}

.header__btn__template__active {
    background-color: $midnight;
    color: $white;
}
</style>
